import { useEffect } from "react";
import "../styles/Contents.css";

export default function FAQs() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return (
    <div className="page">

      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Frequently Asked Questions</h1>
        <p>
          Clear answers to common questions about ACCESS Coaching Institute and our programs.
        </p>
      </section>

      {/* FAQ 1 */}
      <section className="about-section reveal-left">
        <h2>❓ What courses does ACCESS Coaching Institute offer?</h2>
        <p>
          ACCESS offers Classroom Courses, Stay & Study (Hostel programs), Test Series,
          Self Study options, and Study Materials for Classes 8, 9, 10, and Board exams.
        </p>
      </section>

      {/* FAQ 2 */}
      <section className="about-section reveal-right">
        <h2>🏫 What is the Stay and Study program?</h2>
        <p>
          Stay and Study is a residential program where students live in a disciplined
          hostel environment while preparing for exams with structured study hours,
          mentoring, and regular assessments.
        </p>
      </section>

      {/* FAQ 3 */}
      <section className="about-section reveal-left">
        <h2>👨‍🏫 How experienced is the teaching faculty?</h2>
        <p>
          Our faculty consists of highly experienced subject experts with a proven
          track record of producing excellent board results and academic achievers.
        </p>
      </section>

      {/* FAQ 4 */}
      <section className="about-section reveal-right">
        <h2>🧠 Is doubt clearing and mentoring available?</h2>
        <p>
          Yes. Regular doubt-clearing sessions, one-on-one mentoring, performance tracking,
          and personalized academic guidance are provided to all students.
        </p>
      </section>

      {/* FAQ 5 */}
      <section className="about-section reveal-left">
        <h2>📝 How can I enroll in a course?</h2>
        <p>
          Students can enroll by visiting our campus, contacting our admission team,
          or reaching out through the Contact Us page for detailed guidance.
        </p>
      </section>

      {/* FOOTER */}
      <section className="about-footer reveal">
        <p>
          If you have additional questions, feel free to contact ACCESS Coaching Institute.
          Our team is always happy to assist you.
        </p>
      </section>

    </div>
  );
}
